// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isFirstDayOfMonth as fn } from "../isFirstDayOfMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isFirstDayOfMonthWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isFirstDayOfMonthWithOptions;
